var _defs, _defs2, _defs3, _defs4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 17,
    overflow: "visible",
    viewBox: "-1.5 -1.5 19 17",
    width: 19,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-169135941137784",
    d: "M3.7333333333333867 10.23023527973301 C3.7333333333333867 10.23023527973301 3.7333333333333867 13.461289375662165 3.7333333333333867 13.461289375662165 C3.7333333333333867 13.461289375662165 0.533333333333341 13.461289375662165 0.533333333333341 13.461289375662165",
    vectorEffect: "non-scaling-stroke"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(146, 146, 147)",
      strokeWidth: 1.5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      fill: "none"
    },
    d: "M3.2000000000000455 8.612754079388537 C3.2000000000000455 8.612754079388537 3.2000000000000455 11.84380817531769 3.2000000000000455 11.84380817531769 C3.2000000000000455 11.84380817531769 0 11.84380817531769 0 11.84380817531769",
    vectorEffect: "non-scaling-stroke"
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-169135941137682",
    d: "M13.333333333333524 6.999181183803864 C13.333333333333524 6.999181183803864 13.333333333333524 3.768127087874711 13.333333333333524 3.768127087874711 C13.333333333333524 3.768127087874711 16.53333333333357 3.768127087874711 16.53333333333357 3.768127087874711",
    vectorEffect: "non-scaling-stroke"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(146, 146, 147)",
      strokeWidth: 1.5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      fill: "none"
    },
    d: "M12.799999999999955 5.381699983459498 C12.799999999999955 5.381699983459498 12.799999999999955 2.150645887530345 12.799999999999955 2.150645887530345 C12.799999999999955 2.150645887530345 16 2.150645887530345 16 2.150645887530345",
    vectorEffect: "non-scaling-stroke"
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-169135941137680",
    d: "M13.533866666666707 3.7659730518106813 C15.808251672540829 6.15846416265772 16.108502422540994 9.833816373504042 14.253115840215335 12.57026093502117 C12.397729257889674 15.306705496538292 8.895616508359002 16.353667189870958 5.8638222222222405 15.078252447669078",
    vectorEffect: "non-scaling-stroke"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(146, 146, 147)",
      strokeWidth: 1.5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      fill: "none"
    },
    d: "M13.000533333333465 2.1484918514663605 C15.274918339207602 4.540982962313365 15.575169089207748 8.216335173159678 13.719782506882098 10.952779734676824 C11.864395924556447 13.68922429619397 8.362283175025823 14.736185989526575 5.330488888889022 13.460771247324715",
    vectorEffect: "non-scaling-stroke"
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-169135941137578",
    d: "M3.532088888888897 13.463443411725887 C1.262757396551167 11.06987019403469 0.9655305937118843 7.397951560766041 2.819816269589265 4.6640784897554655 C4.674101945466644 1.930205418744891 8.17228592026809 0.882780788066427 11.202844444444471 2.154036063952731",
    vectorEffect: "non-scaling-stroke"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(146, 146, 147)",
      strokeWidth: 1.5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      fill: "none"
    },
    d: "M2.99875555555559 11.845962211381561 C0.7294240632178344 9.452388993690306 0.4321972603785298 5.780470360421646 2.286482936255993 3.0465972894111246 C4.140768612133343 0.3127242184006036 7.638952586934806 -0.7347004122779026 10.669511111111206 0.5365548636084441",
    vectorEffect: "non-scaling-stroke"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.03ac63bba10a45f0903b88754010ebe0.svg";
export { ForwardRef as ReactComponent };